/* eslint-disable no-param-reassign */
function convertToWords(amount) {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine']
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

  function convertChunk(num) {
    if (num === 0) return ''
    if (num < 10) return ones[num]
    if (num < 20) return teens[num - 10]
    if (num < 100) return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`
    return num
  }

  function convertToWordsInternal(number) {
    if (number === 0) return 'Zero'
    let words = ''
    if (number >= 1000000000000) {
      words += `${convertToWordsInternal(Math.floor(number / 1000000000000))} Trillion `
      number %= 1000000000000
    }
    if (number >= 1000000000) {
      words += `${convertToWordsInternal(Math.floor(number / 1000000000))} Billion `
      number %= 1000000000
    }
    if (number >= 1000000) {
      words += `${convertToWordsInternal(Math.floor(number / 1000000))} Million `
      number %= 1000000
    }
    if (number >= 1000) {
      words += `${convertToWordsInternal(Math.floor(number / 1000))} Thousand `
      number %= 1000
    }
    if (number >= 100) {
      words += `${convertChunk(Math.floor(number / 100))} Hundred `
      number %= 100
    }
    if (number > 0) {
      if (words !== '') words += 'and '
      words += convertChunk(number)
    }
    return words
  }

  const naira = 'Naira'
  const kobo = 'Kobo'
  let nairaPart = convertToWordsInternal(Math.floor(amount))
  let koboPart = convertChunk(Math.round((amount % 1) * 100))
  if (koboPart !== '') koboPart += ` ${kobo}`
  if (nairaPart !== '') nairaPart += ` ${naira}`
  if (nairaPart !== '' && koboPart !== '') nairaPart += ' and '
  return nairaPart + koboPart
}
export default convertToWords
